import React, { PropTypes } from 'react';
import { FlatButton } from 'material-ui';
import AccomRateForm from '../rate-forms/accom-rates-form';
import StepperActions from '../stepper-actions';
import R from 'ramda';

const Rates = ({
  componentIndex,
  updateFieldValue,
  goToPreviousStep,
  goToNextStep,
  cancelFunc,
  cancelText,
  calculateRatesTable,
  updateFormData,
  ...fieldValues }) => {
  const requiredFields = ['currency', 'taxInclusion', 'additionalChild', 'additionalAdult', 'includedGuestsinBaseRate', 'maxAdultsChildren', 'maxAdults'];
  const errorFields = ['maxAdultsError', 'maxGuestsError', 'includedGuestsError'];
  const isValueNotExists = field => R.anyPass([R.isEmpty, R.isNil])(R.prop(field, fieldValues));
  const isValueExists = field => R.allPass([R.complement(R.isEmpty), R.complement(R.isNil)])(R.prop(field, fieldValues));

  const disableContinue = (() => {
    if (!fieldValues.taxInclusion) return true;
    if (fieldValues.taxInclusion !== 'exempt' && !fieldValues.taxType) return true;
    if (fieldValues.rateType === 'includeCommission') {
      if (!fieldValues.commissionPercentage || !fieldValues.retailRate) return true;
    }
    return R.or(
      R.any(isValueNotExists)(requiredFields),
      R.any(isValueExists)(errorFields)
    );
  })();
  return (
    <div style={{ padding: '48px' }}>
      <AccomRateForm
        showTaxCurrency
        {...fieldValues}
        updateFieldValue={updateFieldValue}
        updateFormData={updateFormData}
      />

      <StepperActions
        showBackButton
        backButtonFunc={() => goToPreviousStep(componentIndex)}
        rightButtons={
        <div>
          <FlatButton
            label={cancelText}
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={cancelFunc}
          />
          <FlatButton
            onTouchTap={() => {
              calculateRatesTable();
              goToNextStep(componentIndex);
            }}
            disabled={disableContinue}
            secondary
            label={'continue'}
            labelStyle={{ fontWeight: '600' }}
          />
        </div>
        }
      />
    </div>);
};

Rates.propTypes = {
  calculateRatesTable: PropTypes.func,
  goToStep: PropTypes.func,
};

export default Rates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/2-rates.jsx